import { useHandleSignInCallback } from "@logto/react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

const AuthCallback = () => {
  const navigate = useNavigate();

  const { isLoading } = useHandleSignInCallback(() => {
    navigate({ to: "/" });
  });

  if (isLoading) return <div className="p-2">Loading...</div>;

  return null;
};

export const Route = createFileRoute("/callback")({
  component: AuthCallback,
});
